import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { UserModel } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';
import { fade } from 'src/app/util/animations.util';

@Component({
  selector: 'app-change-name',
  templateUrl: './change-name.component.html',
  styleUrls: ['./change-name.component.css'],
  animations: [
    fade
  ]
})
export class ChangeNameComponent implements OnInit {
  form: FormGroup;
  processing: boolean = false;
  currentUser: UserModel = {} as UserModel;
  constructor(
    private fb: FormBuilder,
    private user: UserService,
    private self: MatDialogRef<ChangeNameComponent>
  ) { }

  ngOnInit(): void {
    this.currentUser = this.user.getUser();
    this.form = this.fb.group({
      first_name: [""],
      last_name: [""],
      gender: [""]
    });
    this.form.patchValue({
      first_name: this.currentUser.first_name,
      last_name: this.currentUser.last_name,
      gender: this.currentUser.gender
    })
  }
  onSubmit(): void {
    const value = this.form.value;
    if (this.form.invalid) return this.form.markAllAsTouched();;
    if (value.first_name == this.currentUser.first_name && value.last_name == this.currentUser.last_name && value.gender == this.currentUser.gender) return this.self.close(false);
    this.processing = true;
    this.user.updateProfile(this.form.value)
    .then(() => {
      this.self.close(true);
    })
    .catch(() => {
      this.processing = false;
      this.form.setErrors({
        unknow: true
      });
    })
  }
  get firstName(): FormControl {
    return this.form.get('first_name') as FormControl;
  }
  get lastName(): FormControl {
    return this.form.get('last_name') as FormControl;
  }
  get gender(): FormControl {
    return this.form.get('gender') as FormControl;
  }
}
